import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import Flatpickr from 'react-flatpickr'
import { HTTP } from '../../api/resources'
import SaveReportSettings from './Modals/SaveReportSettings'
import SendReportModal from '../Helpers/Modal/Forms/SendReportModal'

export default function ReportHeader(props) {
  const [fieldOptions, setFieldOptions] = useState(props.fieldOptions)
  const [selectedOptions, setSelectedOptions] = useState(props.selectedFields ? props.selectedFields : [])
  const [donationReportOptions, setDonationReportOptions] = useState([
    {id: 'Invoice', name: 'Invoice'},
    {id: 'Payment', name: 'Payment'}
  ])
  const [donationReportType, setDonationReportType] = useState(props.reportForm ? props.reportForm : donationReportOptions[0])
  const [paymentOptions, setPaymentOptions] = useState([])
  const [selectedPaymentOptions, setPaymentSelectedOptions] = useState(props.payment_options ? props.payment_options : [])
  const [startDate, setStartDate] = useState(props.start_date ? props.start_date : '')
  const [endDate, setEndDate] = useState(props.end_date ? props.end_date : '')
  const [saving, setSaving] = useState(false)
  const [dateLabel, setDateLabel] = useState('Created Date')
  const [orderOptions, setOrderOptions] = useState([
    {id: 'ascending', name: 'Ascending'},
    {id: 'descending', name: 'Descending'}
  ])
  const [savedSettings, setSavedSettings] = useState(props.saved_settings ? props.saved_settings : [])
  const [order, setOrder] = useState(props.order ? orderOptions.find(option => option.id == props.order) : orderOptions[1])
  const [userStatusOptions, setUserStatusOptions] = useState([
    {id: 'Active', name: 'Active (default)'},
    {id: 'Archived', name: 'Archived'},
    {id: 'All', name: 'All'}
  ])
  const [userStatus, setUserStatus] = useState(props.user_status ? userStatusOptions.find(option => option.id == props.user_status) : userStatusOptions[0])
  const [selectedSetting, setSelectedSetting] = useState(null)
  const [openSettingsModal, setOpenSettingsModal] = useState(false)
  const [savingSettings, setSavingSettings] = useState(false)
  const [reportTypeChanged, setReportTypeChanged] = useState(1)
  const [openSendReport, setOpenSendReport] = useState(false)
  const [sendingReport, setSendingReport] = useState(false)

  useEffect(() => {
    if (props.reportType == 'donation') {
      setupFieldOptions()
      initializePaymentOptions()
      setPaymentSelectedOptions([])
      setSelectedOptions([])

      if (donationReportType.id == 'Payment') {
        setDateLabel('Payment Date')
      } else {
        setDateLabel('Created Date')
      }
    }
  }, [reportTypeChanged])

  const reinitializeDonations = () => {
    if (props.reportType == 'donation') {
      setupFieldOptions()
      initializePaymentOptions()
      setPaymentSelectedOptions([])
      setSelectedOptions([])

      if (donationReportType.id == 'Payment') {
        setDateLabel('Payment Date')
      } else {
        setDateLabel('Created Date')
      }
    }
    return ''
  }

  useEffect(() => {
    if (props.reportType == 'donation') {
      setupFieldOptions()
      initializePaymentOptions()
      setSelectedOptions(props.selectedFields ? props.selectedFields : [])
      if (props.payment_options) {
        let updatedOptions = props.payment_options.map(option => {
          if (option.id == 'Beneficiary Sponsorship') {
            return {...option, name: `${props.team.beneficiary_title} Sponsorship`}
          }

          if (option.id == 'Project Donation') {
            return {...option, name: `${props.team.project_title} Donation`}
          }

          return option
        })
        setPaymentSelectedOptions(updatedOptions)
      } else {
        setPaymentSelectedOptions([])
      }
    }
  }, [])
  

  let reportType = props.reportType
  let url = '/reports/donor_export'
  if (reportType === 'beneficiary') {
    url = '/reports/beneficiary_export'
  } else if (reportType === 'donation') {
    url = '/reports/donation_export'
  }

  // set the field options for donations since it is not passed from backend 
  const setupFieldOptions = () => {
    if (donationReportType.name == 'Invoice') {
      let fields = [
        { id: `${props.donorTitle} Name`, name: `${props.donorTitle} Name` },
        { id: 'Invoice Number', name: 'Invoice Number' },
        { id: 'Invoice Date', name: 'Invoice Date' },
        { id: 'Due Date', name: 'Due Date' },
        { id: 'Status', name: 'Status' },
        { id: 'Fully Paid Date', name: 'Fully Paid Date' },
        { id: 'Invoice Amount', name: 'Invoice Amount' },
        { id: 'Balance Remaining', name: 'Balance Remaining' },
        { id: 'Donation Items', name: 'Donation Items' },
        { id: 'Recurring', name: 'Recurring' },
        { id: 'Stripe Payments', name: 'Stripe Payments' }
      ]
      setFieldOptions(current => fields)
    }

    if (donationReportType.name == 'Payment') {
      let fields = [
        { id: `${props.donorTitle} Name`, name: `${props.donorTitle} Name` },
        { id: 'Invoice Number', name: 'Invoice Number' },
        { id: 'Invoice Date', name: 'Invoice Date' },
        { id: 'Due Date', name: 'Due Date' },
        { id: 'Payment Date', name: 'Payment Date' },
        { id: 'Payment Method', name: 'Payment Method' },
        { id: 'Payment Amount', name: 'Payment Amount' },
        { id: 'Invoice Amount', name: 'Invoice Amount' },
      ]
      setFieldOptions(current => fields)
    }
  }

  // dynamically handle payment options
  const initializePaymentOptions = () => {
    if (donationReportType.name == 'Payment') {
      let options = [
        { id: 'All', name: 'All'},
        { id: 'Cash', name: 'Cash'},
        { id: 'Check', name: 'Check'},
        { id: 'Offline', name: 'Offline'},
        { id: 'Stripe Auto Charged', name: 'Stripe Auto Charged'},
        { id: 'Stripe Single Payment', name: 'Stripe Single Payment'},
      ]
      setPaymentOptions(current => options)
    }

    if (donationReportType.name == 'Invoice') {
      let options = [
        { id: 'Fully Paid', name: 'Fully Paid'},
        { id: 'Balance Remaining', name: 'Balance Remaining'},
        { id: 'Beneficiary Sponsorship', name: `${props.team.beneficiary_title} Sponsorship`},
        { id: 'Project Donation', name: `${props.team.project_title} Donation`}
      ]
      setPaymentOptions(current => options)
    }
  }

  const handleReportTypeChange = (option) => {
    setDonationReportType(option)
    setReportTypeChanged(reportTypeChanged + 1)
  }

  const handleSelectedPaymentOptions = (options) => {
    setPaymentSelectedOptions(options)
    if (options.some(option => option.id === 'All')) {
      if (options[options.length - 1].id === 'All') {
        setPaymentSelectedOptions([{ id: 'All', name: 'All'}])
      } 
      if (options[options.length - 1].id !== 'All') {
        setPaymentSelectedOptions(options.filter(option => option.id !== 'All'))
      }
    }
    if (options.some(option => option.id === 'Fully Paid') && options.some(option => option.id === 'Balance Remaining')) {
      setPaymentSelectedOptions([options[options.length - 1]]);
    }
  }

  // setup request submittion to backend 
  const handleSubmit = async () => {
    if (selectedOptions.length === 0) {
      Alert.show('error', 'Select at least one field')
      return
    }

    setSaving(true)

    if (reportType == 'donation') {
      try {
        await postRequest({
          donation_report_fields: selectedOptions.map(option => option.id),
          donation_report_type: donationReportType.id,
          donation_payment_options: selectedPaymentOptions.map(option => option.id),
          donation_start_date: startDate,
          donation_end_date: endDate,
          donation_order: order.id
        })
        window.location = `${url}`
      } catch {
        Alert.show('error', 'Failed to generate report, try again later')
        setSaving(false)
      }
    }

    if (reportType == 'donor') {
      try {
        await postRequest({
          donor_report_fields: selectedOptions.map(option => option.id),
          donor_start_date: startDate,
          donor_end_date: endDate,
          donor_report_order: order.id,
          user_status: userStatus.id,
        })
        window.location = `${url}`
      } catch {
        Alert.show('error', 'Failed to generate report, try again later')
        setSaving(false)
      }
    }

    if (reportType == 'beneficiary') {
      try {
        await postRequest({
          beneficiary_report_fields: selectedOptions.map(option => option.id),
          beneficiary_start_date: startDate,
          beneficiary_end_date: endDate,
          beneficiary_report_order: order.id,
          user_status: userStatus.id,
        })
        window.location = `${url}`
      } catch {
        Alert.show('error', 'Failed to generate report, try again later')
        setSaving(false)
      }
    }
  }

  const postRequest = (data) => {
    return HTTP.post(`${url}/generate_report`, {report: data})
  }

  const handleSaveSettings = async (name) => {
    if (selectedOptions.length === 0) {
      Alert.show('error', 'Select at least one field')
      return
    }

    setSavingSettings(true)

    let data = []

    if (reportType == 'donation') {
      data = {
        fields: selectedOptions.map(option => option.id),
        donation_report_type: donationReportType.id,
        donation_filter_options: selectedPaymentOptions.map(option => option.id),
        start_date: startDate,
        end_date: endDate,
        order: order.id,
        name: name,
        report_type: reportType
      }
    }

    if (reportType == 'donor') {
      data = {
        fields: selectedOptions.map(option => option.id),
        start_date: startDate,
        end_date: endDate,
        order: order.id,
        name: name,
        report_type: reportType
      }
    }

    if (reportType == 'beneficiary') {
      data = {
        fields: selectedOptions.map(option => option.id),
        start_date: startDate,
        end_date: endDate,
        order: order.id,
        name: name,
        report_type: reportType
      }
    }

    try{
      let response = await saveSettingsRequest(data)
      setSavedSettings(response.data)
      Alert.show('notice', 'Settings saved successfully')
      setSavingSettings(false)
      setOpenSettingsModal(false)
    } catch {
      Alert.show('error', 'Unable to save settings, please try again')
      setSavingSettings(false)
    }
  }

  const saveSettingsRequest = (data) => {
    return HTTP.post(`/reports/save_report_settings?type=${reportType}`, {report: data})
  }

  const handleDeleteSettings = async (setting) => {
    setSavingSettings(true)

    try{
      let response = await deleteSettingsRequest(setting.id)
      setSavedSettings(response.data)
      setSavingSettings(false)
      Alert.show('notice', 'Saved settings deleted successfully')
    } catch {
      Alert.show('error', 'Unable to save settings, please try again later')
    }
  }

  const deleteSettingsRequest = (id) => {
    return HTTP.delete(`/reports/delete_report_settings?id=${id}&type=${reportType}`)
  }

  const handleUseSettings = (setting) => {
    let fields = fieldOptions
    let options = paymentOptions

    if (reportType == 'donation') {
      setDonationReportType(donationReportOptions.find(item => item.id == setting.donation_report_type))

      // change states based on the donation report type
      if (setting.donation_report_type == 'Payment') {
        fields = [
          { id: `${props.donorTitle} Name`, name: `${props.donorTitle} Name` },
          { id: 'Invoice Number', name: 'Invoice Number' },
          { id: 'Invoice Date', name: 'Invoice Date' },
          { id: 'Due Date', name: 'Due Date' },
          { id: 'Payment Date', name: 'Payment Date' },
          { id: 'Payment Method', name: 'Payment Method' },
          { id: 'Payment Amount', name: 'Payment Amount' },
          { id: 'Invoice Amount', name: 'Invoice Amount' },
        ]
        setFieldOptions(current => fields)

        options = [
          { id: 'All', name: 'All'},
          { id: 'Cash', name: 'Cash'},
          { id: 'Check', name: 'Check'},
          { id: 'Offline', name: 'Offline'},
          { id: 'Stripe Auto Charged', name: 'Stripe Auto Charged'},
          { id: 'Stripe Single Payment', name: 'Stripe Single Payment'},
        ]
        setPaymentOptions(current => options)
        setDateLabel('Payment Date')
      } else {
        fields = [
          { id: `${props.donorTitle} Name`, name: `${props.donorTitle} Name` },
          { id: 'Invoice Number', name: 'Invoice Number' },
          { id: 'Invoice Date', name: 'Invoice Date' },
          { id: 'Due Date', name: 'Due Date' },
          { id: 'Status', name: 'Status' },
          { id: 'Fully Paid Date', name: 'Fully Paid Date' },
          { id: 'Invoice Amount', name: 'Invoice Amount' },
          { id: 'Balance Remaining', name: 'Balance Remaining' },
          { id: 'Donation Items', name: 'Donation Items' },
          { id: 'Recurring', name: 'Recurring' },
          { id: 'Stripe Payments', name: 'Stripe Payments' }
        ]
        setFieldOptions(current => fields)

        options = [
          { id: 'Fully Paid', name: 'Fully Paid'},
          { id: 'Balance Remaining', name: 'Balance Remaining'},
          { id: 'Beneficiary Sponsorship', name: `${props.team.beneficiary_title} Sponsorship`},
          { id: 'Project Donation', name: `${props.team.project_title} Donation`}
        ]
        setPaymentOptions(current => options)
        setDateLabel('Created Date')
      }

      setPaymentSelectedOptions(
        options
          .filter(item => setting.donation_filter_options.includes(item.id))
          .sort((a, b) => setting.donation_filter_options.indexOf(a.id) - setting.donation_filter_options.indexOf(b.id))
      );
    }

    setSelectedOptions(
      fields
        .filter(item => setting.fields.includes(item.id))
        .sort((a, b) => setting.fields.indexOf(a.id) - setting.fields.indexOf(b.id))
    );
    setStartDate(setting.start_date)
    setEndDate(setting.end_date)
    setOrder(orderOptions.find(item => item.id == setting.order))

    Alert.show('notice', `${setting.name} applied successfully`)
    setOpenSettingsModal(false)
  }

  const sendReport = async (email) => {
    setSendingReport(true)

    if (selectedOptions.length === 0) {
      Alert.show('error', 'Select at least one field')
      return
    }

    if (reportType == 'donation') {
      try {
        await sendEmailRequest(email)
        setSendingReport(false)
        setOpenSendReport(false)
        Alert.show('notice', 'Report will be sent shortly to provided email address as CSV')
      } catch {
        Alert.show('error', 'Failed to send report, try again later')
        setSendingReport(false)
      }
    }

    if (reportType == 'donor') {
      try {
        await sendEmailRequest(email)
        setSendingReport(false)
        setOpenSendReport(false)
        Alert.show('notice', 'Report will be sent shortly to provided email address as CSV')
      } catch {
        Alert.show('error', 'Failed to send report, try again later')
        setSendingReport(false)
      }
    }

    if (reportType == 'beneficiary') {
      try {
        await sendEmailRequest(email)
        setSendingReport(false)
        setOpenSendReport(false)
        Alert.show('notice', 'Report will be sent shortly to provided email address as CSV')
      } catch {
        Alert.show('error', 'Failed to send report, try again later')
        setSendingReport(false)
      }
    }
  }

  const sendEmailRequest = (email) => {
    return HTTP.post(`${url}/send_report`, {email: email})
  }

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  return (
    <div>
      <div><strong>Customize and Filter Report</strong></div>
      <div className='row'>
        <div className='col-md-12'>
          <div className='form-group'>
            <label>Select Data Fields</label>
            <div className="input-group">
                <Select
                  className="w-100 select-audience"
                  classNamePrefix="select-audience"
                  isMulti
                  value={selectedOptions}
                  onChange={(value) => setSelectedOptions(value)}
                  options={fieldOptions}
                  getOptionLabel={option => `${option.name}`}
                  getOptionValue={option => option.id}
                />
            </div>
            <small>You can reorder the columns by deselecting the fields and then reselecting them in your preferred order.</small>
          </div>
        </div>
        <div className='col-md-6'></div>
      </div>

      {reportType == 'donation' &&
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>Donation Report Type</label>
              <div className="input-group" id="order">
                <Select
                  className="form-control select-beneficiaries"
                  classNamePrefix="select-beneficiaries"
                  onChange={(option) => handleReportTypeChange(option)}
                  options={donationReportOptions}
                  getOptionLabel={(option) =>
                      `${option.name}`
                  }
                  getOptionValue={(option) => option.id}
                  value={donationReportType}
                />
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>Filter Options</label>
              <div className="input-group" id="order">
                <Select
                    className="form-control select-beneficiaries"
                    classNamePrefix="select-beneficiaries"
                    isMulti
                    onChange={(order) => handleSelectedPaymentOptions(order)}
                    options={paymentOptions}
                    getOptionLabel={(option) =>
                        `${option.name}`
                    }
                    getOptionValue={(option) => option.id}
                    value={selectedPaymentOptions}
                />
              </div>
            </div>
          </div>
        </div>
      }
      

      <div className='row'>
        <div className='col-md-6'>
          <div className='form-group'>
            <label>Start Date <small>( { dateLabel } )</small></label>
            <div className="input-group">
              <Flatpickr className="form-control"
                value={startDate}
                onChange={(date, dateStr) => {
                    setStartDate(dateStr)
                }}
              />
            </div>
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form-group'>
            <label>End Date <small>( { dateLabel } )</small></label>
            <div className="input-group">
              <Flatpickr className="form-control"
                value={endDate}
                onChange={(date, dateStr) => {
                    setEndDate(dateStr)
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='row'>
        <div className='col-md-6'>
          <div className='form-group'>
            <label>Order Report (Created Date)</label>
            <div className="input-group" id="order">
              <Select
                className="form-control select-beneficiaries"
                classNamePrefix="select-beneficiaries"
                onChange={(option) => setOrder(option)}
                options={orderOptions}
                getOptionLabel={(option) =>
                    `${option.name}`
                }
                getOptionValue={(option) => option.id}
                value={order}
              />
            </div>
          </div>
        </div>
        <div className='col-md-6'>
          {reportType !== 'donation' &&
            <div className='form-group'>
              <label>{capitalizeFirstLetter(reportType)}</label>
              <div className="input-group" id="report_type">
                <Select
                  className="form-control select-report-type"
                  classNamePrefix="select-report-type"
                  onChange={(option) => setUserStatus(option)}
                  options={userStatusOptions}
                  getOptionLabel={(option) =>
                      `${option.name}`
                  }
                  getOptionValue={(option) => option.id}
                  value={userStatus}
                />
              </div>
            </div>
          }
        </div>
      </div>
      

      <div className='row'>
        <div className='col-md-12'>
          <div className='pull-right'>
            <div className="btn-group">
              <button 
                className='btn btn-primary' 
                onClick={handleSubmit}
                disabled={saving}
              >
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                Generate Report
              </button>
              <>
                <button 
                  type="button" 
                  className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" 
                  data-toggle="dropdown" 
                  aria-expanded="false"
                >
                  <span className="sr-only">Toggle Dropdown</span>
                </button>
                <ul className="dropdown-menu dropdown-menu-right">
                  <li>
                    <button onClick={() => setOpenSettingsModal('create')}
                      name="button"
                      className="dropdown-item"
                      type="button">
                        Save Settings
                    </button>
                  </li>
                  <li>
                    <button onClick={() => setOpenSettingsModal('manage')}
                      name="button"
                      className="dropdown-item"
                      type="button">
                        Manage Saved Settings
                    </button>
                  </li>
                </ul>
              </>
            </div>
            <button 
              className='btn btn-primary ml-2'
              onClick={() => setOpenSendReport(true)}
              disabled={saving || !props.rowsPresent}
            >
              Export Report
            </button>
          </div>
        </div>
      </div>

      {openSettingsModal &&
        <SaveReportSettings
          close={() => setOpenSettingsModal(false)} 
          save={(name) => handleSaveSettings(name)}
          deleteSetting={(setting) => handleDeleteSettings(setting)}
          use={(setting) => handleUseSettings(setting)}
          settings={savedSettings}
          saving={savingSettings}
          type={openSettingsModal}
        />
      }

      {openSendReport &&
        <SendReportModal
          primaryEmail={props.currentUser.email}
          handleSubmit={(email) => sendReport(email)}
          close={() => setOpenSendReport(false)}
          saving={sendingReport}
        />
      }
    </div>
  )
}
